import { useState, useEffect } from 'react';
import axios from 'axios';
import { PhoneForwarded } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function CallTransfer({ callId, onTransferred }) {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [transferType, setTransferType] = useState('blind');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/agents`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAgents(response.data);
    } catch (error) {
      console.error('Error fetching agents:', error);
    }
  };

  const handleTransfer = async () => {
    if (!selectedAgent) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${API_BASE}/dialer/calls/${callId}/transfer`,
        {
          to_agent_id: selectedAgent,
          transfer_type: transferType,
          reason
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onTransferred?.();
    } catch (error) {
      console.error('Error transferring call:', error);
      alert('Failed to transfer call');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-3">
      <h3 className="font-semibold flex items-center gap-2">
        <PhoneForwarded className="w-5 h-5" />
        Transfer Call
      </h3>
      <div>
        <label className="block text-sm font-medium mb-1">Transfer Type</label>
        <select
          value={transferType}
          onChange={(e) => setTransferType(e.target.value)}
          className="w-full border rounded px-3 py-2"
        >
          <option value="blind">Blind Transfer</option>
          <option value="warm">Warm Transfer</option>
          <option value="conference">Conference</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Transfer To</label>
        <select
          value={selectedAgent}
          onChange={(e) => setSelectedAgent(e.target.value)}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select agent...</option>
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name || agent.email}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Reason (optional)</label>
        <input
          type="text"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border rounded px-3 py-2"
          placeholder="Why are you transferring?"
        />
      </div>
      <button
        onClick={handleTransfer}
        disabled={!selectedAgent || loading}
        className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400"
      >
        {loading ? 'Transferring...' : 'Transfer Call'}
      </button>
    </div>
  );
}


